module.exports = __webpack_public_path__ + "img/dver-logo.5c98a2ca.svg";